<template>
  <div class="lnb-wrapper">
    <h1 class="a11y-hidden">웨이브</h1>
    <div class="lnb-side-wrap">
      <div class="lnb-side-top">
        <div class="lnb-alarm-close">
          <a href="#" class="alarm" @click.prevent="showAlarm" v-if="loginState">
            <PushEmptyIcon v-if="!isNewAlarms"></PushEmptyIcon>
            <PushIcon v-else></PushIcon>
          </a>
          <button class="close" @click="closeLnb">
            <span class="a11y-hidden">닫기</span>
            <LnbCloseIcon></LnbCloseIcon>
          </button>
        </div>
        <div class="lnb-profile-side">
          <span class="profile-txt">
            <template v-if="hasLogin">
              <span class="profile-name">
                <span>{{name}}</span>
                <span>님</span>
              </span>
              <a href="" class="lnb-logout" @click.prevent="goLogout">로그아웃</a>
              <a href="" class="profile-link" @click.prevent="showUserInfo">
                <span class="profile-link-txt">회원정보</span>
                <NextButtonGrey></NextButtonGrey>
              </a>
            </template>
            <template v-if="!hasLogin">
              <span class="profile-txt">로그인 해주세요</span>
              <a href="" class="lnb-login" @click.prevent="showLogin">
                <span class="lnb-login-txt">로그인</span>
                <NextButtonGrey></NextButtonGrey>
              </a>
            </template>
          </span>
          <a href="#" class="profile-img-box">
            <span class="profile-img">
                <img v-if="!loginState" src="../../assets/images/ci-pooq-id.png" alt="프로필 이미지">
                <img v-if="loginState" :src="'https://' + profileImage" alt="프로필 이미지">
            </span>
          </a>
        </div>
      </div>

      <!-- 로그인 하고 프로모션이 있을때-->
      <div v-for="(voucher, index) in voucherInfo.list" :key="index">
        <a href="#" class="lnb-ticket"  @click.prevent="goSubscriptionTicket" v-if="index === 0 ">
          <span>
            <p class="lnb-product-txt">{{voucher.producttext}}</p>
            <p class="lnb-attribute-txt" v-convert-dot="voucher.attributetext"></p>
          </span>
          <NextButtonGrey></NextButtonGrey>
        </a>
      </div>
        <div v-if="loginState && promotion"  class="lnb-promotion">
          <p class="lnb-promotion-txt">
            <span v-if="promotion.text1" style="color: #fff;">{{ promotion.text1 }}</span>
            <span v-if="promotion.text2" style="color: #3887ff;">{{ promotion.text2 }}</span>
          </p>
          <a @click.prevent="clickPromotion" href="#" class="lnb-promotion-link">
            <span>{{ promotion.button }}</span>
          </a>
        </div>
      <!--로그인 후, 이용권 보유시-->

      <div class="lnb-voucher" v-if="!loginState">
        <img src="../../assets/images/img-live.png" alt="live icon">
        <p class="lnb-voucher-txt">
          <span>회원가입하면 지상파 포함</span>
          <span>80 여개 LIVE 채널 무료!</span>
        </p>
        <a href="" class="lnb-join-link" @click.prevent="goJoin">회원가입</a>
      </div>

      <div class="lnb-list">
        <ul>
          <li @click.prevent="goHome">
            <span>홈</span>
            <NextButtonGrey></NextButtonGrey>
          </li>
          <li @click.prevent="goMyPooq">
            <span>MY</span>
            <NextButtonGrey></NextButtonGrey>
          </li>
          <li @click.prevent="goCategorySearch">
            <span>카테고리 검색</span>
            <NextButtonGrey></NextButtonGrey>
          </li>
          <li @click.prevent="goVoucher">
            <span>이용권</span>
            <NextButtonGrey></NextButtonGrey>
          </li>
          <li @click.prevent="goEvent">
            <span>이벤트<strong class="lnb-list-strong">{{eventCount}}</strong></span>
            <NextButtonGrey></NextButtonGrey>
          </li>
          <li @click.prevent="goCustomerService">
            <span>고객센터</span>
            <NextButtonGrey></NextButtonGrey>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import utils from '@/common/util/utils'
import { mapGetters, mapMutations } from 'vuex'
import { UserService, EventService } from '@/common/api/api.service'
import { convertDot } from '@/common/directives'
import { get } from 'lodash'
import PushEmptyIcon from '@/assets/svg/common/ic-push-empty.svg'
import PushIcon from '@/assets/svg/common/ic-push.svg'
import LnbCloseIcon from '@/assets/svg/common/ic_gnb_close_w.svg'
import NextButtonGrey from '@/assets/svg/common/ic-next-s-g.svg'
import { enableBodyScroll } from '@/common/util/ui.utils'
import { URL_COOKIE_DOMAIN } from '@/common/constant'
export default {
  name: 'LnbSlideMenu',
  components: {
    PushEmptyIcon,
    PushIcon,
    LnbCloseIcon,
    NextButtonGrey
  },
  directives: {
    convertDot
  },
  data () {
    return {
      voucherInfo: {},
      loginState: utils.cookies.getCredential() !== 'none',
      profileName: utils.cookies.userInfo('profilename'),
      name: utils.cookies.userInfo('name'),
      profileCount: utils.cookies.userInfo('profilecount'),
      profileImage: utils.cookies.userInfo('profileimage'),
      eventCount: '0',
      promotion: null,
      myPass: null,
      isNewAlarms: false
    }
  },
  computed: {
    ...mapGetters([ 'lnbStatus', 'getBeforePathOpenMyPooq' ]),
    hasLogin () {
      return this.loginState
    }
  },
  methods: {
    ...mapMutations({ showLnb: 'showLnb',
      hideLnb: 'hideLnb',
      showCategorySearch: 'showCategorySearch',
      showAlarms: 'showAlarms',
      setCategorySearchTab: 'setCategorySearchTab'
    }),
    closeLnb () {
      this.hideLnb()
    },
    showLogin () {
      this.hideLnb()
      this.$router.push({ name: 'login', query: { referer: this.$route.fullPath } })
    },
    goLogout () {
      utils.login.logoutProc().then(() => {
        this.hideLnb()
        location.reload()
      })
    },
    showUserInfo () {
      this.$router.push({ name: 'lnbUserInfo', query: { referer: this.$route.fullPath } })
    },
    goSubscriptionTicket () {
      this.hideLnb()
      this.$router.push('/mypooq/subscription_ticket')
    },
    goHome () {
      this.hideLnb()
      this.$router.push('/')
    },
    goJoin () {
      let encodeLocationHref = encodeURIComponent(window.location.href)
      location.href = 'https://member.wavve.com/mobile/account?returnurl=' + encodeLocationHref
      // alert('회원가입은 스마트폰을 이용해 wavve 모바일웹(http://familyhub.pooq.co.kr)에서 진행해 주세요.')
    },
    goEvent () {
      this.hideLnb()
      this.$router.push('/event/list')
    },
    async goMyPooq () {
      if (!this.loginState) {
        if (await utils.asyncConfirm('로그인이 필요한 메뉴입니다. 로그인 페이지로 이동하시겠습니까?')) {
          this.hideLnb()
          this.$router.replace('/login')
        } else {
          return
        }
      }
      this.hideLnb()
      this.$router.push({
        name: 'mypooq'
      })
    },
    goCategorySearch () {
      enableBodyScroll()
      this.setCategorySearchTab('broadCast')
      this.hideLnb()
      this.$router.push('/search/category')
    },
    goCustomerService () {
      this.hideLnb()
      this.$router.push('/customer/faq')
    },
    goVoucher () {
      this.hideLnb()
      this.$router.push({ name: 'voucher' })
    },
    showAlarm () {
      this.hideLnb()
      this.$router.push({ name: 'alarmNoticeList' })
    },
    discount () {
      this.hideLnb()
      this.$router.push('/voucher/recommend')
    },
    clickPromotion () {
      utils.common.clickLink(this.promotion.link)
    }
  },
  created () {
    UserService.userPurchaseProducts({
      productType: 'all',
      autoPayment: 'all',
      orderBy: 'all',
      offset: 0,
      limit: 10
    }).then(({ data }) => {
      this.voucherInfo = data
    })

    EventService.getEvents({
      status: 'all',
      offset: 0,
      limit: 5
    }).then(({ data }) => {
      this.eventCount = data.pagecount
    })
    UserService.getUserSummary().then(({ data }) => {
      const promotionList = get(data, 'promotion', [])
      if (promotionList.length > 0) {
        this.promotion = promotionList[0]
      }
      this.myPass = get(data, 'mypass', '')
    })
    UserService.getAlarmsNewCount().then(({ data }) => {
      this.isNewAlarms = data.count > 0
    })
    if (this.loginState) {
      UserService.profiles({ offset: 0, limit: 10, orderby: 'new' }).then(({ data }) => {
        const profile = utils.cookies.userInfo('profile')
        if (this.profileImage !== data.list[profile].image) {
          const cs = JSON.parse(utils.cookies.getItem('cs'))
          cs.profileimage = data.list[profile].image
          utils.cookies.setItem('cs', JSON.stringify(cs), null, URL_COOKIE_DOMAIN, '/')
          this.profileImage = utils.cookies.userInfo('profileimage')
        }
      })
    }
  }
}
</script>

<style scoped>
dd, dl, dt, ol, ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.profile-img img {
  width: 100%;
}

/*
.side-my-coin li {
  display: inline-block;
  vertical-align: top;
  margin-right: 46px;
}
.side-my-coin li a {
  font-size: 12px;
  color: #23212a;
}
a, a:active, a:hover, a:link, a:visited {
  text-decoration: none;
}
.side-my-coin img {
  display: block;
  width: 47px;
}
*/
</style>
